// extracted by mini-css-extract-plugin
export var anchor = "_4l-0";
export var discard = "_4l-4";
export var muiTooltipTooltip = "_4l-6";
export var notificationBar = "_4l-3";
export var saveButtonHoverSlotWrapper = "_4l-5";
export var show = "_4l-2";
export var spacer = "_4l-1";